import { IFilterAction } from "./filterActions.types";
import {FiltersActions} from "./filteractions.enum"

const initState = {
  searchPhrase: "",
  searchFields: undefined,
  searchMode: undefined,
  filter: false,
  column: "",
  finished: true,
};

export const filtersReducer = (state = initState, action: IFilterAction) => {
  const { type, payload } = action;
  switch (type) {
    case FiltersActions.SET_SEARCH_PHRASE:
      return {
        ...state,
        searchPhrase: payload.searchPhrase,
        searchFields: payload.searchFields,
        searchMode: payload.searchMode,
      };
    case FiltersActions.SET_SORTING:
      return { ...state, column: payload.column };
    case FiltersActions.TOGGLE_FILTRATION:
      return { ...state, filter: payload.filter };
    case FiltersActions.SET_FINISHED:
      return { ...state, finished: payload.finished}
    case FiltersActions.CLEAR:
      return { ...initState };
    default:
      return state;
  }
};
